// Phase −1 patches to this file:
//
// 1. The 401 handler now redirects to /login (previously it only logged to
//    console, leaving the user staring at a broken screen).
//
// 2. Defensive comment: this client never sent client-supplied identity
//    headers (clinicId, loggedInUserId, etc.) — unlike ajax-utils.js, which
//    used to. No change required here, but worth documenting that any future
//    additions should NOT add such headers. The backend's SecurityFilter
//    reads identity from the validated JWT only.

import axios from 'axios'
import environment from 'environments/environment'
const { baseUrl } = environment

const axiosClient = axios.create({
  baseURL: baseUrl,
  headers: {
    'Content-Type': 'application/json',
    'application-id': 2,
    // Do NOT add 'ClinicId', 'loggedInUserId', 'userName', 'roleId',
    // or 'roleName' headers here. They were never trusted by the backend,
    // and after the SecurityFilter patch, the backend overwrites them
    // from the JWT regardless. Sending them is misleading at best.
  },
})

axiosClient.interceptors.request.use((config) => {
  const token = localStorage.getItem('access_token')
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
})

const AUTH_FAILURE_STATUSES = new Set([401, 403])

axiosClient.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status
    if (AUTH_FAILURE_STATUSES.has(status)) {
      // Clear local auth state and bounce to login. The user's token is
      // either invalid, expired, or rejected by the backend (e.g. missing
      // required claims after Phase −1).
      try {
        localStorage.removeItem('access_token')
        localStorage.removeItem('refreshToken')
      } catch (e) {
        // localStorage unavailable (private mode, etc.) — ignore
      }
      // Only redirect if we're not already on /login, to avoid loops
      if (!window.location.pathname.endsWith('/login')) {
        window.location.replace('/login')
      }
    }
    return Promise.reject(error)
  },
)

export default axiosClient
